angular.module('iqxCore')
.controller('OwnerDiaryCtrl', function ($scope, $q, FormSvc, ApiSvc, ApplicationSvc, actionDialogSvc, $routeParams) {
	$scope.checkPermissions('OWNER')
	$scope.selectedConsultant={}
	$scope.addoredit="A" // A = Add | E = Edit (used for getting the correct wording)

	FormSvc.setOptions($scope,{
		fetchAPI:'callresult/netownerdiary'+($scope.selectedConsultant.ConsultantID ? '?pConsultantID='+$scope.selectedConsultant.ConsultantID+'&' : '?')+'pStartDate='+moment().subtract(3, 'months').format('YYYY-MM-DD')+' 00:00'+'&pEndDate='+moment().add(10, 'years').format('YYYY-MM-DD')+' 23:59',
		multiRow:true,
		doNotPreventNav:true
	})

	$scope.getConsultantList=function(){
		return $scope.fetch({
			fetchAPI:'callresult/NetOwnerRequirementConsultantList',
			fetchTarget:'consultantList',
			multiRow:true,
			doNotPreventNav:true
		})
	}

	$scope.selectConsultant=function(){
		$scope.reload()
	}

	function extractDateTime(dt,tm) {
		if (dt.indexOf(' ') == 3) {dt=dt.substr(4)}
		if (tm) {dt=dt+' '+tm}
		return moment(dt,'DD/MM/YYYY HH:mm').toDate()
	}

	function normaliseTimes(){
		angular.forEach($scope.events,function(evt){
			if (moment(evt.startsAt).isSame(evt.endsAt,'minute')){
				if (evt.DiaryStatus == "Reminder") {
					evt.endsAt=moment(evt.endsAt).add(15, "minutes").toDate()
				} else {
					evt.endsAt=undefined
				}
			}
		})
	}

	$scope.slide=function(n){
		if(n){
			$scope.calendarDate = moment($scope.calendarDate).add(n, $scope.calendarView).toDate()
		}
	}

	$scope.deleteEvent=function(id) {
		angular.forEach($scope.events, function(event,ix) {
			if (event.DiaryID==id) (delete $scope.events[ix])
		})
	}

	$scope.changeDate=function(myScope,changed) {
		if (myScope.theRecord.xDateFrom>myScope.theRecord.xDateTo) {
			if (changed=='from') {
				myScope.theRecord.xDateTo=myScope.theRecord.xDateFrom
			} else {
				myScope.theRecord.xDateFrom=myScope.theRecord.xDateTo
			}
		}
	}

	$scope.calendarClicked=function(calendarCell, calendarDate, $event){
		if (!calendarCell) { // we're in day view, just create an event on the exact clicked date & time!
			$scope.enterAppointment(calendarDate)
		} else { // we're in a view that doesn't pass the full date & time
			if ($event.srcElement.className.includes("pull-right")) {
				// We clicked on the number! not the cell itself!
				$scope.enterAppointment(calendarDate)
			}
		}
	}

	$scope.enterAppointment=function(dateClicked) {
		$scope.addoredit="A"
		if (moment(dateClicked).format('HH:mm') == "00:00") {
			// if the date we just clicked doesn't include a time, set it to their CONSDIARYSTARTTIME param
			var CONSDIARYSTARTTIME=moment(ApplicationSvc.params.CONSDIARYSTARTTIME, "HH:mm")
		}
		var data={
			xNew:true,
			xType:'Appointment',
			xDateFrom:moment(dateClicked).toDate(),
			xTimeFrom:(CONSDIARYSTARTTIME) ? CONSDIARYSTARTTIME : dateClicked,
			xPopupMinutes:0
		}
		var newData={}
		$scope.xCaption='Add Entry'
		FormSvc.modalForm($scope,'diaryApptEdit',data,'md',{label:'col-sm-3', data:'col-sm-7'})
		.then(function(data){
			if (data !== undefined) {
				if ($scope.selectedConsultant.ConsultantID) {
					newData.pStaffID = $scope.selectedConsultant.ConsultantID
				}
				newData.pAction='N'
				newData.pDescription=data.xDescription
				newData.pStartDate=moment(data.xDateFrom).format('DD/MM/YYYY')
				newData.pStartTime=moment(data.xTimeFrom).format('HH:mm')
				if (data.xPopupMinutes!=0 && data.xPopupMinutes_checkbox) {
					newData.pMinutesBefore=data.xPopupMinutes
				}
				if(data.xType=='Appointment'){
					if (!data.xDateTo) {
						newData.pEndDate=newData.pStartDate
					} else {
						newData.pEndDate=moment(data.xDateTo).format('DD/MM/YYYY')
					}          
					newData.pEndTime=moment(data.xTimeTo).format('HH:mm')
				}
				if(data.xNotes){
					newData.pNotes=data.xNotes
				}
				return $scope.exec('call/NetOwnerDiarySet',newData)
			}
		})
		.then(function() {
			return $scope.load()
		})
		.catch(function (err) {
			if (err && err!="backdrop click" && err!="escape key press") {ApplicationSvc.showMessage('Error',err,true)}
		})
	}

	$scope.eventClicked=function(evt) {
		$scope.addoredit="E"
		var theChoice=''
		var desc=evt.title
		var times=moment(evt.startsAt).format('DD/MM/YYYY HH:mm')
		if(evt.endsAt){
			if (moment(evt.startsAt).isSame(evt.endsAt,'day')) {
				times=times+' to '+moment(evt.endsAt).format('HH:mm')
			} else {
				times=times+' to '+moment(evt.endsAt).format('DD/MM/YYYY HH:mm')
			}
		}

		var choices=[{desc:'Close',type:'primary',code:''},{desc:'Edit',type:'success',code:'E'},{desc:'Delete',type:'danger',code:'D'}]

		if (evt.CandidateID) {
			choices.push({desc:'View Person',type:'info',code:'ACand'})
		}

		if (evt.ContactID) {
			choices.push({desc:'View Client',type:'info',code:'ACont'})
		}

		$scope.xCaption=evt.DiaryStatus
		var data={desc:desc,times:times,address:evt.Address,map:evt.MapQuery,notes:evt.DiaryNotes,choices:choices,LinkedContactInformation:evt.LinkedContactInformation}
		FormSvc.modalInfo($scope,'diaryApptInfo',data)
		.then(function(choice){
			switch(choice){
				case 'E':
					return $scope.doEdit(evt)
				case 'D':
					return $scope.doDelete(evt)
				case 'ACand':
					return $scope.viewActionDialog(evt.CandidateID, evt.CandName, 'Person')
				case 'ACont':
					return $scope.viewActionDialog(evt.ContactID, evt.CompanyName, 'Contact')
			}
		})
	}

	$scope.viewActionDialog=function(linkID, name, type){
		let theObj={
			linkID:linkID, // Contains the ID of the person, vacancy, client etc...
			type:type // Person, Vacancy, Client etc...
		}

		actionDialogSvc.show($scope, theObj)
	}

	$scope.doEdit=function(evt) {
		if (!evt.PopupMinutes) {
			evt.PopupMinutes=0
			var MinutseBeforeTick=false
		} else {
			var MinutseBeforeTick=true
		}
		var data={xNew:false,
			xType:evt.DiaryStatus,
			xDateFrom:evt.startsAt,
			xTimeFrom:evt.startsAt,
			xDateTo:evt.endsAt,
			xTimeTo:evt.endsAt,
			xDescription:evt.title,
			xPopupMinutes:evt.PopupMinutes,
			xPopupMinutes_checkbox:MinutseBeforeTick,
			xNotes:evt.DiaryNotes
		}
		var safeData=angular.copy(data)
		var newData={}
		$scope.xCaption='Edit '+evt.DiaryStatus
		FormSvc.modalForm($scope,'diaryApptEdit',data,'md',{label:'col-sm-3', data:'col-sm-7'})
		.then(function(data){
				newData.pStartDate=moment(data.xDateFrom).format('DD/MM/YYYY')
				newData.pStartTime=moment(data.xTimeFrom).format('HH:mm')
				if(data.xType=='Appointment'){
					newData.pEndDate=moment(data.xDateTo).format('DD/MM/YYYY')
					newData.pEndTime=moment(data.xTimeTo).format('HH:mm')
					}

			if (data.xPopupMinutes!=0 && data.xPopupMinutes_checkbox) {
				newData.pMinutesBefore=data.xPopupMinutes
			}

			if(data.xDescription!=safeData.xDescription){
				newData.pDescription=data.xDescription
			}
			if(data.xNotes!=safeData.xNotes){
				newData.pNotes=data.xNotes
			}
			if(angular.equals(newData,{})){
				return $q.when('NoChange')
			}
			newData.pAction='U'
			if(data.xType=='Appointment'){
				newData.pEventType="A"
			} else {
				newData.pEventType="R"
			}
			newData.pDiaryID=evt.DiaryID
			return $scope.exec('call/NetOwnerDiarySet',newData)
			})
		.then(function(res) {
			if (res!='NoChange'){
				return $scope.load()
			}
			})
		.catch(function (err) {
			if (err) {ApplicationSvc.showMessage('Error',err,true)}
			})
	}

	$scope.doDelete=function(evt) {
		ApplicationSvc.queryMessage('Delete '+evt.DiaryStatus,'Delete "'+evt.title+'" at '+moment(evt.startsAt).format('DD/MM/YYYY HH:mm')+' ?')
		.then(function() {
			return $scope.exec('call/NetOwnerDiarySet',{pAction:'D',pDiaryID:evt.DiaryID})
			})
		.then(function() {
			$scope.deleteEvent(evt.DiaryID)
			})
		.catch(function (err) {
			if (err) {ApplicationSvc.showMessage('Error',err,true)}
			})
	}

	$scope.viewChangeClicked=function(calendarDate, calendarNextView){
		return false   // We don't want to change view other than by one of the buttons
	}

	$scope.showKey=function(){
		var choices=[{desc:'Close',type:'primary',code:''}]
		var data={choices:choices}
		FormSvc.modalInfo($scope,'diaryKey',data)
	}

	$scope.reload=function(){
		return $scope.fetch({
		fetchAPI:'callresult/netownerdiary'+($scope.selectedConsultant.ConsultantID ? '?pConsultantID='+$scope.selectedConsultant.ConsultantID+'&' : '?')+'pStartDate='+moment().subtract(3, 'months').format('YYYY-MM-DD')+' 00:00'+'&pEndDate='+moment().add(10, 'years').format('YYYY-MM-DD')+' 23:59',
			multiRow:true
		})
		.then(function() {
			$scope.events=[]
			angular.forEach($scope.theRecords,function(row) {
				if (row.PopupMinutes) {
					var minsBefore = parseInt(row.PopupMinutes)
				}
				$scope.events.push({title:row.Description,
					type:(row.Status=='R'?'important':'success'),
					startsAt:extractDateTime(row.DiaryFrom),
					endsAt:extractDateTime(row.DiaryTo),
					editable:false,
					deletable:false,
					DiaryStatus:(row.Status=='R'?'Reminder':'Appointment'),
					cssClass:(row.Status=='R'?'Available':'Working'), // Quick work around to get styling onto the diary
					DiaryNotes:row.Notes,
					DiaryID:row.DiaryID,
					LinkedContactInformation:row.Speil,
					PopupMinutes:minsBefore,
					CandidateID:row.CandID,
					ContactID:row.ContactID,
					VacancyID:row.VacID,
					CandName:row.CandName,
					CompanyName:row.CompanyName,
					ContactName:row.ContactName,
					VacancyName:row.VacPos
					//Address:row.Address,
					//MapQuery:row.MapQuery,       // for google maps
					})
				})
			$scope.theRecords=[] // Free the memory
			normaliseTimes()  // Deletes endsAt if same as startsAt. Makes for cleaner display
		})
		.then(function(){
			$scope.eventsList=angular.copy($scope.events)
			angular.forEach($scope.eventsList, function(event, key){
				$scope.eventsList[key].eventMonthYear=moment(event.startsAt).format("MMMM YYYY")
			})
			$scope.eventMonthyearNow=moment().format("MMMM YYYY")
		})
	}

	$scope.load=function() {
		return $scope.fetch()
		.then(function() {
			$scope.events=[]
			angular.forEach($scope.theRecords,function(row) {
				if (row.PopupMinutes) {
					var minsBefore = parseInt(row.PopupMinutes)
				}

				$scope.events.push({title:row.Description,
					type:(row.Status=='R'?'important':'success'),
					startsAt:extractDateTime(row.DiaryFrom),
					endsAt:extractDateTime(row.DiaryTo),
					editable:false,
					deletable:false,
					DiaryStatus:(row.Status=='R'?'Reminder':'Appointment'),
					cssClass:(row.Status=='R'?'Available':'Working'), // Quick work around to get styling onto the diary
					DiaryNotes:row.Notes,
					DiaryID:row.DiaryID,
					LinkedContactInformation:row.Speil,
					PopupMinutes:minsBefore,
					CandidateID:row.CandID,
					ContactID:row.ContactID,
					VacancyID:row.VacID,
					CandName:row.CandName,
					CompanyName:row.CompanyName,
					ContactName:row.ContactName,
					VacancyName:row.VacPos
					//Address:row.Address,
					//MapQuery:row.MapQuery,       // for google maps
					})
				})
			$scope.theRecords=[] // Free the memory
			normaliseTimes() //- this breaks it now, removed  // Deletes endsAt if same as startsAt. Makes for cleaner display
			})
			.then(function(){
				$scope.eventsList=angular.copy($scope.events)
				angular.forEach($scope.eventsList, function(event, key){
					$scope.eventsList[key].eventMonthYear=moment(event.startsAt).format("MMMM YYYY")
				})
				$scope.eventMonthyearNow=moment().format("MMMM YYYY")
			})
		}

	$scope.events=[]
	$scope.cellIsOpen=true
	$scope.calendarDate=new Date() // today
	$scope.calendarView= ($routeParams.view ? $routeParams.view : 'day')

	$scope.load()
	.then(function(){
		$scope.getConsultantList()
		.then(function(){
			angular.forEach($scope.consultantList, function(element, index) {
				if (element.ThisIsMe == true) {
					$scope.selectedConsultant = element
				}
			})
		})
	})

})
